export const LIST_PROCEDURE = 'LIST_PROCEDURE';
export const LIST_PROCEDURE_KEY = 'LIST_PROCEDURE_KEY';

export const COLORS = [
  { id: 'orange', color: [255, 165, 0], name: 'Orange' },
  { id: 'blue', color: [0, 123, 255], name: 'Blue' },
  { id: 'green', color: [40, 167, 69], name: 'Green' },
  { id: 'red', color: [220, 53, 69], name: 'Red' },
  { id: 'purple', color: [108, 117, 125], name: 'Purple' },
];

export const DEFAULT_SHAPE_COLORS = [
  [255, 165, 0],
  [0, 191, 255],
  [128, 128, 128],
  [34, 139, 34],
  [105, 105, 105],
  [160, 82, 45],
  [139, 69, 19],
  [255, 0, 0],
  [255, 255, 0],
  [128, 0, 128],
];
